import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { GroupingConferenceDivision } from "~pages/Standings/enums/groupingConferenceDivision";
import type { GroupingStagePool } from "~pages/Standings/enums/groupingStagePool";
import type { FilterParams } from "~pages/Standings/types/filterParams";
import { transformStandingResponse } from "~pages/Standings/utilities/transform";
import type { StandingResponse } from "~types/standing";

export const useFetchAllStandings = (
  params: FilterParams,
  enabled: boolean,
  grouping?: GroupingStagePool,
  conferenceGrouping?: GroupingConferenceDivision,
) => {
  const enhancedRequest = useApi();
  const { organizationId, sport, seasonId } = useParams();
  const { formatMessage } = useIntl();

  let url = `${sport}/o/${organizationId}/seasons/${seasonId}/standings`;

  if (!isEmpty(params)) {
    url += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["standings", sport, organizationId, seasonId, params],
    queryFn: async () => {
      const response: StandingResponse = await enhancedRequest(url);
      return transformStandingResponse(response, formatMessage, grouping, conferenceGrouping);
    },
    enabled,
  });
};
